
import Table2 from './Table2'

function Tab3() {
    return (
        <div
            className="row  m-0"
            style={{ padding: "8px", borderRadius: "5px" }}
        >
            <div className="col-12">

                <div className="tableLabel">
                    <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '16px' }}>
                        Payment Schedule
                    </p>


                </div>
                <div >
                    <Table2 />
                </div>

            </div>
        </div>
    )
}

export default Tab3
